export default __webpack_public_path__ + "static/media/score_background.37ec95fe.jpg";